import { makeStyles } from '@material-ui/core/styles';


export default makeStyles(() => ({
  root: {
    margin: 0,
    padding: 0,
    maxWidth: 'none',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
  },
}));